import React from 'react';
import { GridCell } from '@progress/kendo-react-grid';

export default function cellEditDeleteButtonRtCert(onEdit, onDelete) {
  return class extends GridCell {

    render() {
      if (this.props.dataItem.rtCertStatusRef != 1)
        return <td></td>
      
      return (
        <td>
          <button class="k-button k-flat k-button-icontext" onClick={() => { onEdit(this.props.dataItem); }}>
            <span role="presentation" class="k-icon k-i-edit"></span></button>
          <button class="k-button k-flat k-button-icontext" onClick={() => { onDelete(this.props.dataItem); }}>
            <span role="presentation" class="k-icon k-i-delete"></span></button>

        </td>
      );
    }
  };
}